import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useStyles = makeThemedStyles("InputContainer", (theme) => ({
  root: {
    margin: "0px",
    marginBottom: "30px",
    borderRadius: "15px",
    overflow: "hidden",
  },
  heading: {
    background: "none",
    textAlign: "start",
    fontFamily: "Arial",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1.25em",
    letterSpacing: "0em",
    color: "#374151",
    margin: "4px",
    marginInlineStart: "22px",
  },
  errors: {
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginInlineStart: "24px",
    paddingInlineStart: "9px",
    borderInlineStart: "3px solid #ff8833",
    marginBottom: "3px",
    marginTop: "3px",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    /*
    background: "#EFF0F0",
    border: "0.11em solid #D1D5DB",
    boxShadow: "0em 0.11em 0.22em rgba(0, 0, 0, 0.05)",
    */
    borderRadius: "0.68em",
    margin: "0em 22px 0 22px",
  },
}));
/*
height: 2em; width: 2em; margin-right: 1.065em; margin-left: 0.66em; background: rgb(0, 169, 163); -webkit-mask: url("http://localhost:4000/http://localhost:4000/api/files/?file=/icons/navitems/corporate.svg") center center / contain no-repeat;
*/
const InputContainer = (
  props: React.PropsWithChildren<{
    title?: string | JSX.Element;
    errorMessages?: string[];
    width?: string;
  }>
) => {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ width: props.width }}>
      <div className={classes.heading}>{props.title}</div>
      <div className={classes.content}>{props.children}</div>

      <div className={classes.errors}>
        {props.errorMessages?.map((msg, i) => {
          if (!msg) return null;
          return (
            <div className={classes.error} key={[msg, i].join(":")}>
              {msg}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InputContainer;
